export const cleanCpfCnpj = (value) => value && value.replace(/\D+/g, '');
